import React from "react";
import { ConfigureNotificationsContainer } from "../../containers/notifications";
export const ConfigureNotifications = () => <ConfigureNotificationsContainer />;
